import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';

interface ModifiedSugarProps {
  cx?: number;
  cy?: number;
  radius: number;
  stroke: string;
  strokeWidth?: number;
}

export default function ModifiedSugar({
  cx = 0,
  cy = 0,
  radius,
  stroke,
  strokeWidth = 1.5,
}: ModifiedSugarProps): JSX.Element {
  return (
    <circle
      className="modifiedSugar"
      stroke={stroke}
      strokeWidth={strokeWidth}
      r={radius}
      fill="none"
      cx={cx}
      cy={cy}
      shapeRendering="geometricPrecision"
      {...getTestProps({component: 'ModifiedSugar', element: 'root'})}
    />
  );
}
